export function money(value: string | number, compact = false) {
  const number = Number(value) || 0;
  return new Intl.NumberFormat("zh-CN", {
    style: "currency",
    currency: "CNY",
    maximumFractionDigits: compact ? 0 : 2,
    notation: compact ? "compact" : "standard",
  }).format(number);
}

export function percent(value: string | number) {
  return `${(Number(value) || 0).toFixed(2)}%`;
}

export function shortDate(value?: string | null) {
  if (!value) return "暂无";
  const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(value) ? `${value.replace(" ", "T")}Z` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.valueOf())) return value;
  return new Intl.DateTimeFormat("zh-CN", { timeZone: "Asia/Shanghai", year: "numeric", month: "short", day: "numeric" }).format(date);
}

export function serverDateTime(value?: string | null) {
  if (!value) return "暂无";
  const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(value) ? `${value.replace(" ", "T")}Z` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.valueOf())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(date);
}

export const statusLabel = {
  draft: "测算中",
  in_transit: "运输中",
  in_stock: "已入库",
  sold: "已售出",
  settled: "已结算",
} as const;
